<section class="fullWidthCls admPageSec">
  <div class="container-fluid">
    <div class="row">
      <div class="access-denied-page-sec">
        <div class="headerCls">
         {{logoutNote}}
        </div>
      </div>
    </div>
  </div>
</section>



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/logout/logout.component.html